<template>
    <div>

        <div v-if="sitePlanLoading">
            <div class="row">
                <div class="col-md-12 text-center pt-5 pb-5 mt-5 pb-5">
                    <i class="fa fa-circle-notch fa-spin fa-10x fa-fw" aria-hidden="true"></i>
                </div>
            </div>
        </div>

        <div v-if="sitePlanFound === false && sitePlanLoading === false">
            <div class="row pb-4">
                <div class="col-md-8">
                    <h2 class="page-header-title">Sorry...</h2>
                </div>
            </div>
            <div class="widget">
                <div class="widget-body">
                    <p>The site plan could not be found. Please check the URL and try again.</p>
                    <p> <router-link to="/">Return Home</router-link></p>
                </div>
            </div>
        </div>

        <div v-if="sitePlan">

            <div class="row pb-4">
                <div class="col-md-10">
                    <h2 class="page-header-title">
                        <router-link to="/">
                            Door Inspections</router-link>
                        &raquo;
                        <router-link :to="{ name: 'door-check-view', params: {action: 'view', id: doorCheck.site_door_check_id} }">
                            {{ doorCheck.document_id }} | {{ doorCheck.document_title }}
                        </router-link>
                        &raquo;
                        {{ sitePlan.site_plan_title }}        </h2>
                </div>
                <div class="col-md-2">
                    <router-link :to="{ name: 'door-check-edit-site-plan', params: {id: parseInt(sitePlan.site_door_check_site_plan_id)} }" class="btn btn-outline-secondary btn-square btn-lg pull-right">
                        Edit Site Plan
                    </router-link>
                </div>
            </div>


            <div class="widget" v-if="sitePlan.offline_site_plan_image == null && sitePlan.site_plan_image != null">
                <div class="widget-header bordered no-actions d-flex align-items-center">
                    <h3>Site Plan Image</h3>
                </div>
                <div class="widget-body">
                    <div class="row">
                        <div class="col-sm-12" >
                            <img class="img-fluid" v-bind:src="this.cmsUrl + sitePlan.site_plan_image">
                        </div>
                    </div>
                </div>
            </div>

            <div class="widget" v-if="sitePlan.offline_site_plan_image != null">
                <div class="widget-header bordered no-actions d-flex align-items-center">
                    <h3>Offline Site Plan Image</h3>
                </div>
                <div class="widget-body">
                    <div class="row">
                        <div class="col-md-12">
                            <div class="alert alert-warning">
                                <p class="mb-0 pb-0">Image in this section has not yet been synced with the server.</p>
                            </div>
                        </div>
                    </div>
                    <div class="row">

                        <div class="col-sm-12">
                            <img v-bind:src="sitePlan.offline_site_plan_image.data" class="img-fluid">
                            <div class="image-actions">
                                <button v-on:click="rotatePhoto(-90)" :disabled="modifyingPhoto" class="btn btn-primary btn-xs btn-square" title="Rotate Anti-clockwise"><i class="fa fa-undo"></i></button>
                                <button v-on:click="rotatePhoto(90)" :disabled="modifyingPhoto" class="btn btn-primary btn-xs btn-square" title="Rotate Clockwise"><i class="fa fa-undo fa-flip-horizontal"></i></button>
                            </div>
                        </div>

                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-xl-12 col-md-12 col-sm-12">
                    <div class="widget has-shadow">
                        <div class="widget-body border-bottom">
                            <router-link :to="{ name: 'door-check-add-site-plan', params: {id: doorCheck.site_door_check_id} }" class="btn btn-outline-primary btn-square pt-3 pb-3 mt-3 mb-3" style="display:block;width:100%">
                                Add Site Plan
                            </router-link>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>
</template>

<script>

    import ImageRotate from '@/components/mixins/ImageRotate.js'

    export default {
        mixins: [ImageRotate],
        data() {
            return {
                sitePlan: null,
                sitePlanFound: false,
                sitePlanLoading: true,
                doorCheck: {
                    door_check_id: null,
                    document_id: 'Loading...',
                    document_title: 'Please wait...',
                    site_door_check_id: null,
                },
                modifyingPhoto: false,
                site_door_check_id: null
            }
        },
        methods: {
            getSitePlan() {
                var vm = this;
                this.getDb(function onConnected(db) {
                    try {
                        var sitePlanId = parseInt(vm.$route.params.id);
                        var objectStore = db.transaction('door_check_site_plans').objectStore('door_check_site_plans');
                        var storeRequest = objectStore.get(sitePlanId);
                        storeRequest.onsuccess = function(event) {
                            vm.sitePlan = storeRequest.result;
                            if (storeRequest.result !== undefined) {
                                vm.getDoorCheck();
                                vm.sitePlanFound = true;
                                vm.site_door_check_id = storeRequest.result.site_door_check_id;
                            }
                            vm.sitePlanLoading = false;
                        };
                        storeRequest.onerror = function(e) {
                            vm.sitePlanFound = false;
                            vm.sitePlanLoading = false;
                        }
                    } catch (e) {
                        console.log(e);
                    }

                })
            },
            getDoorCheck() {
                var vm = this;
                this.getDb(function onConnectedGetDoorSets(db) {
                    try {
                        var reportId = vm.sitePlan.site_door_check_id;
                        var objectStore = db.transaction('door_checks').objectStore('door_checks');
                        var storeRequest = objectStore.get(reportId);
                        storeRequest.onsuccess = function(event) {
                            vm.doorCheck = storeRequest.result;
                        };
                        storeRequest.onerror = function(e) {
                            console.log(e);
                        }
                    } catch (e) {
                        console.log(e);
                    }

                })
            },
            rotatePhoto(degrees) {
                this.modifyingPhoto = true;
                this.rotateImage(this.sitePlan.offline_site_plan_image.data, degrees).then(newDataUri => {
                    this.sitePlan.offline_site_plan_image.data = newDataUri;

                    var vm = this;
                    this.getDb(function onConnectedGetDoorSets(db) {
                        var putRequest = db.transaction('door_check_site_plans', 'readwrite')
                            .objectStore('door_check_site_plans').put(vm.sitePlan);
                        putRequest.onsuccess = function(event) {
                            vm.modifyingPhoto = false;
                        };
                        putRequest.onerror = function(event) {
                            alert("Unable to rotate photo");
                            window.location = '';
                        };
                    });
                }).catch(e => {
                    console.log(e);
                    alert('Error occurred while trying to rotate photo');
                    this.modifyingPhoto = false;
                });
            },
        },
        mounted () {
            const modulesData = this.$session.get('enabled_modules');
            if(!modulesData || modulesData.indexOf('FDR') === -1) {
                this.$router.push('/');
                return;
            }
            
            this.getSitePlan();
        },
    }
</script>